/* lua.js generated code 0.3.1 */
require("clover/gamePlay/CreateGameSceneLogic")
let PopUpAction = require("activity/CoinMatchActivity/CoinMatchBackPopupAction")

let StartCoinMatchLevelLogic = xClass("StartCoinMatchLevelLogic")

StartCoinMatchLevelLogic.create = function (levelId) {
    return [StartCoinMatchLevelLogic.new(levelId)]
}
StartCoinMatchLevelLogic.prototype.ctor = function (levelId) {
    let self = this
    self.levelId = levelId
    self.isBusy = false
    self.initProps = table()
    self.successCallback = null
    self.failCallback = null
}
StartCoinMatchLevelLogic.prototype.initLevelLogics = function () {
    require.ensure([], () => {
        require("clover/scene/GameScene")
        require("clover/scene/GameSceneUI")
        FailLevelLogicClassTypeRef[GameLevelType.kCoinMatch] = require("activity/CoinMatchActivity/startEndLevelLogic/FailCoinMatchLevelLogic")
        PassLevelLogicClassTypeRef[GameLevelType.kCoinMatch] = require("activity/CoinMatchActivity/startEndLevelLogic/PassCoinMatchLevelLogic")
        QuitLevelLogicClassTypeRef[GameLevelType.kCoinMatch] = require("activity/CoinMatchActivity/startEndLevelLogic/QuitCoinMatchLevelLogic")
        GameReviveLogicClassTypeRef[GameLevelType.kCoinMatch] = require("activity/CoinMatchActivity/startEndLevelLogic/ReviveCoinMatchLevelLogic")
    }, null, 'game')
}
StartCoinMatchLevelLogic.prototype.start = function (onSuccess, onFail) {
    let self = this
    // self.initLevelLogics()
    self.successCallback = onSuccess
    self.failCallback = onFail
    self.startLevel()
}
StartCoinMatchLevelLogic.prototype.levelInfo = function () {
    let self = this
    let ret = table([1, "gameplayMode", LevelConfigManager.getInstance().getLevelGameMode(self.levelId)])
    let levelType = LevelType.getLevelTypeByLevelId(self.levelId)
    ret.levelType = levelType
    ret.levelId = self.levelId
    return ret
}
StartCoinMatchLevelLogic.prototype.startLevelReplay = function(replay, id, score) {
    let self = this
    var logic = CreateGameSceneLogic.create(self.levelId, table()) //selectedItemsData
    logic.startReplayGamePlayScene(replay, id, score, function() {
        self.initLevelLogics()
    })
}
StartCoinMatchLevelLogic.prototype.startLevel = function () {
    let self = this
    let context = this
    let instance = CreateGameSceneLogic.create(context.levelId, context.initProps)
    function fail(event = {}) {
        Toast.make(curryQuickGetErrorText(event.data), 1, () => {
            let sceneName = cc.director._runningScene.name || cc.director._runningScene._name
            if (sceneName !== "HomeScene") {
                cc.Director.getInstance().popScene();
            }
            self.callFail();
        })
    }
    instance.startGamePlayScene(
        (fileList)=> {
            CoinMatchManager.getInstance().startLevel(self.levelId);
            self.callSuccess();
            context.initLevelLogics()
            instance.createGamePlayScene(fileList)      
            
            HomeScenePopoutQueue.getInstance().pushBack(PopUpAction.create(CoinMatchManager.getInstance().getPassedLevelStep()));
        }, 
        fail);
    UserLevel.getInstance().setCurrentLevel(null);
}

StartCoinMatchLevelLogic.prototype.callSuccess = function() {
    let successCallback = this.successCallback;
    this.clearCallbacks();

    if (successCallback != null)
        successCallback();
}

StartCoinMatchLevelLogic.prototype.callFail = function() {
    let failCallback = this.failCallback;
    this.clearCallbacks();

    if (failCallback != null)
        failCallback();
}

StartCoinMatchLevelLogic.prototype.clearCallbacks = function() {
    this.successCallback = null
    this.failCallback = null
}

module.exports = StartCoinMatchLevelLogic